import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

class Copay extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/08_copay.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Who pays? Copays</H2>

            <P>
              A copay is a flat fee you’ll pay up front for services. It’s usually collected at the
              doctor’s office, and the fee varies depending on the service.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Copay;
